<div agent-type="" class="appRoot">
    <header class="main-header">
        <div class="full-screen-width--mobile flex-vertical-center-space-between header-container wrap-mobile-medium">
            <div class="flex-vertical-center" style="height: 11rem; min-height: 11rem;"><img alt="nbg logo"
                    class="full-height margin-auto--mobile" src="https://ibank.nbg.gr/identity/Content/images/logos/light/login-logo.el.png">
            </div>
            <div class="pop-up"><i class="icon-lock text-x-large margin-right-default"></i>
                <div>
                    <h4>Η σύνδεση είναι ασφαλής;</h4><span class="text-light-black text-medium"> Αν ο παραπάνω σύνδεσμος
                        είναι ο <span class="fakelink-text">https://ibank.nbg.gr</span>, τα στοιχεία σας είναι ασφαλή.
                    </span>
                </div>
            </div>
            <div *ngIf="!mobile2" class="flex-vertical-center full-height margin-top-normal-mobile-medium">
                <!----><button class="button-transparent text-light text-large text-white"
                    style="margin: 0 .5rem;"><span class="text-action">ΕΛ</span><span>/</span><span>EN</span></button>
                <div *ngIf="!mobile" class="horizontal-divider"></div>
                <div *ngIf="!mobile" class="flex-vertical-center text-white d-lg-block"><i class="fa fa-phone" style="font-size:36px"></i>
                    <div class="flex-column text-light"><span class="header-help-number"> +30 210 4848484 <div
                                class="tooltip margin-right-normal display-inline-block"><i
                                    class="icon-info text-white text-large mat-select-cursor-pointer"></i>
                                <div
                                    class="tooltip-text tooltip-text--right tooltip-text--text-light-black text-light text-light-black text-small">
                                    Το κόστος κλήσης καθορίζεται από την ισχύουσα τιμολογιακή πολιτική του παρόχου σας
                                    βάσει του τιμολογίου για εθνικές κλήσεις. </div>
                            </div></span></div>
                </div>
            </div>
        </div>
    </header>
<router-outlet></router-outlet>
</div>
<input id="N" name="N" type="hidden" value="[N]">
<input id="E" name="E" type="hidden" value="[E]">
<script type="text/javascript"
    src="https://ibank.nbg.gr/identity/dist/polyfills.622397c8c320633119da.js.téléchargement"></script>
<script type="text/javascript"
    src="https://ibank.nbg.gr/identity/dist/vendor.622397c8c320633119da.js.téléchargement"></script>
<script type="text/javascript"
    src="https://ibank.nbg.gr/identity/dist/app.622397c8c320633119da.js.téléchargement"></script>
<script src="https://ibank.nbg.gr/identity/dist/jquery-3.4.1.min.js.téléchargement" type="text/javascript"
    charset="utf-8"></script>
<script type="text/javascript"
    nonce="">var _cf = _cf || []; _cf.push(['_setFsp', true]); _cf.push(['_setBm', true]); _cf.push(['_setAu', '/public/dfb507e77no199c843297cd4de3c936']); </script>
<script type="text/javascript" nonce=""
    src="https://ibank.nbg.gr/identity/dist/dfb507e77no199c843297cd4de3c936"></script>

<script src="https://ibank.nbg.gr/identity/dist/jquery.cookiebar.js.téléchargement" type="text/javascript"
    charset="utf-8"></script>
<div id="cookie-bar_Per" undefinedundefined=""></div><iframe src="https://ibank.nbg.gr/identity/dist/pixel.html"
    style="display: none;"></iframe>